import React from "react";
import { useTranslation } from "react-i18next";
import { FiAlertCircle, FiAlertTriangle } from "react-icons/fi";
import {
  REQUESTS_LEFT_WARNING_THRESHOLD,
  useChatRequestsLeft,
} from "../../helpers/chatRequestsLeft";

const ChatLimitBanner: React.FC = () => {
  const { t } = useTranslation();
  const requestsLeft = useChatRequestsLeft();

  if (requestsLeft === null || requestsLeft >= REQUESTS_LEFT_WARNING_THRESHOLD) {
    return null;
  }

  const isError = requestsLeft === 0;

  return (
    <div
      role={isError ? "alert" : "status"}
      className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ${
        isError
          ? "border-red-300 bg-red-50 text-red-800 dark:border-red-500/40 dark:bg-red-500/10 dark:text-red-300"
          : "border-yellow-300 bg-yellow-50 text-yellow-800 dark:border-yellow-500/40 dark:bg-yellow-500/10 dark:text-yellow-300"
      }`}
    >
      {isError ? (
        <FiAlertCircle className="flex-shrink-0" />
      ) : (
        <FiAlertTriangle className="flex-shrink-0" />
      )}
      <span>
        {isError
          ? t("chatAI.requestsLimitReached")
          : t("chatAI.requestsLeftWarning", { left: requestsLeft })}
      </span>
    </div>
  );
};

export { ChatLimitBanner };
